import { createMetadata } from "../../lib/seo";

export const metadata = createMetadata({
  title: "服务条款",
  description:
    "增长深度 GrowDeep 服务条款，说明品牌增长与产品出海服务的范围、结果边界、交付约定及知识产权规则。",
  path: "/terms",
  keywords: [
    "增长深度服务条款",
    "GrowDeep服务条款",
    "品牌增长服务条款",
    "产品出海服务条款",
    "项目交付约定",
    "知识产权约定",
  ],
});
export default function TermsPage() {
  return (
    <article className="legal-page">
      <h1>服务条款</h1>
      <p>更新日期：2026 年 7 月 30 日</p>
      <h2>服务范围</h2>
      <p>
        网站所列服务和价格为参考信息。具体服务内容、交付物、项目周期、费用、验收方式与双方职责，以双方正式确认的项目合同、服务说明或订单文件为准。
      </p>
      <h2>结果边界</h2>
      <p>
        增长深度将按约定推进品牌资产、内容资产、搜索基础、咨询入口与持续优化动作。增长结果受行业、产品竞争力、市场环境、企业协作效率及客户决策周期等多重因素影响，因此不保证固定排名、固定询盘量、最终销售额或市场份额。
      </p>
      <h2>知识产权</h2>
      <p>
        项目中各方提供的资料、第三方素材与最终交付物的权利归属、使用范围及交付方式，以双方签署的项目文件为准。客户应确保其提供资料的合法性与使用授权。
      </p>
    </article>
  );
}
